// HTML module entry. Polyfills + styles first; React for createRoot only; App via
// dynamic import so shared app modules are NOT in this chunk (avoids lazy routes
// importing the entry → WebKit circular-init hang).
import "./bootPolyfills.js";
import "./bootStyles.js";
import React from "react";
import { createRoot } from "react-dom/client";

const rootEl = document.getElementById("root");

(async function boot() {
  try {
    if (!rootEl) {
      throw new Error("Missing #root element");
    }
    const appMod = await import("./App.jsx");
    const App = appMod.default;
    if (typeof App !== "function" && (typeof App !== "object" || !App)) {
      throw new Error("App module default export missing");
    }
    createRoot(rootEl).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (err) {
    console.error("Failed to boot app:", err);
    if (rootEl) {
      rootEl.innerHTML =
        '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:system-ui,sans-serif;color:#b91c1c;padding:24px;text-align:center">Failed to start DataDripper. Please refresh.</div>';
    }
  }
})();
